import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { lettermemeLatestPath } from "~/common/paths"
import { getMetaContent } from "~/common/get-meta-content"

const DEFAULT_LETTERMEME_PATH = getMetaContent("default-lettermeme-path")

export const RootScreen = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(lettermemeLatestPath({ urlPath: DEFAULT_LETTERMEME_PATH }))
  }, [navigate])

  return null
}
